export const localize = (transalte, key) => {
	if (typeof (key) === 'string') {
		return transalte(key);
	} else if (typeof (key) === 'object') {
		return key.value
	}
};

export const untranslatable = (untranslatable, transalte, key, value) => {
	if (untranslatable.includes(key)) {
		return value;
	} else {
		return transalte(key);
	}
};



// WEBPACK FOOTER //
// ./src/utilities/localize.js